export default {
    toolbar: {
        items: [
            'heading',
            '|',
            'bold',
            'italic',
            'link',
            'bulletedList',
            'numberedList',
            '|',
            'alignment',
            '|',
            'indent',
            'outdent',
            '|',
            'fontFamily',
            'fontColor',
            '|',
            'blockQuote',
            'horizontalLine',
            'insertTable',
            'mediaEmbed',
            'ckfinder',
            '|',
            'undo',
            'redo',
            'removeFormat',
        ],
    },
}
